import React, { memo } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

// Active reactions shown in the picker
export const REACTIONS = [
	{ type: "love", label: "Love", emoji: "❤️" },
	{ type: "like", label: "Like", emoji: "👍" },
	{ type: "haha", label: "Haha", emoji: "😂" },
	{ type: "clap", label: "Clap", emoji: "👏" },
	{ type: "wow", label: "Wow", emoji: "😮" },
	{ type: "insight", label: "Insight", emoji: "💡" },
];

// All known types including legacy (for displaying badges from old data)
export const ALL_REACTION_TYPES = [
	...REACTIONS,
	{ type: "shocked", label: "Shocked", emoji: "😲" },
	{ type: "insightful", label: "Insightful", emoji: "💡" },
];

interface IReactionPicker {
	onReact: (type: string) => void;
	myReaction?: string | null;
	isComment?: boolean;
}

const ReactionPicker: React.FunctionComponent<IReactionPicker> = ({
	onReact,
	myReaction = null,
	isComment = false,
}) => {
	// Hide the "+ React" trigger when user has already reacted
	if (myReaction) return null;

	return (
		<div className={styles.reactionPickerWrap}>
			<div className={classNames(styles.reactionPopover, { [styles.commentSize]: isComment })}>
				{REACTIONS.map((reaction) => {
					const isActive = myReaction === reaction.type;
					return (
						<div
							key={reaction.type}
							className={classNames(styles.emojiOption, { [styles.selected]: isActive, [styles.commentSize]: isComment })}
							onClick={() => onReact(reaction.type)}
							role="button"
							tabIndex={0}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === " ") {
									e.preventDefault();
									onReact(reaction.type);
								}
							}}
						>
							<span className={classNames(styles.em, { [styles.commentSize]: isComment })}>{reaction.emoji}</span>
							<span className={classNames(styles.label, { [styles.commentSize]: isComment })}>{reaction.label}</span>
						</div>
					);
				})}
				<div className={styles.arrow} />
			</div>
			<span className={classNames(styles.reactTrigger, { [styles.commentSize]: isComment })}>+ React</span>
		</div>
	);
};

export default memo(ReactionPicker);
